import { BuyCreditsModal } from "@/components/credits/BuyCreditsModal";
import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";
import { Route as SummaryRoute } from "./index";

const historyStateSchema = z
  .object({
    neededCredits: z.number(),
  })
  .optional()
  .catch(undefined);

const parseHistoryState = (historyState: z.infer<typeof historyStateSchema>) =>
  historyStateSchema.parse(historyState);

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/summary/buy-credits",
)({
  staticData: {
    crumb: "Tilkøb credits",
    meta: {
      title: "Tilkøb credits",
    },
  },
  beforeLoad: ({ location }) => {
    const historyState = parseHistoryState(
      location.state.routeStates?.[Route.id],
    );

    if (!historyState) throw redirect({ to: ".." });

    return {
      parseHistoryState,
      useHistoryState: () => historyState,
    };
  },
  loader: () => ({
    showCampaignSetupBottomBar: false,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();

  const historyState = context.useHistoryState();

  const navigate = Route.useNavigate();

  const goBack = async (shouldContinue: boolean) => {
    await navigate({
      to: "/campaigns/setup/summary",
      state: shouldContinue
        ? {
            routeStates: {
              [SummaryRoute.id]: {
                autoSubmit: true,
              },
            },
          }
        : undefined,
    });
  };

  return (
    <BuyCreditsModal
      neededCredits={historyState.neededCredits}
      onClose={() => goBack(false)}
      onSuccess={() => goBack(true)}
      onSkip={() => goBack(true)}
    />
  );
}
